import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import { CRM_RECORDS_PAGE_SIZE } from "app/pages/sales-intelligence/modules/crm-integration/constants/dto";
import type { LeadsSearchRowWithKey } from "app/pages/sales-intelligence/modules/leads-search";

export const getLoadingRowsNumber = <R extends LeadsSearchRowWithKey>({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    salesforce_accounts_count = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    hubspot_accounts_count = 0,
}: R, integrationProvider: CrmIntegrationProvider) => {
    if (integrationProvider === "salesforce") {
        return Math.min(salesforce_accounts_count, CRM_RECORDS_PAGE_SIZE);
    }

    if (integrationProvider === "hubspot") {
        return Math.min(hubspot_accounts_count, CRM_RECORDS_PAGE_SIZE);
    }

    return CRM_RECORDS_PAGE_SIZE;
};